export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-eye-55e148d016e1488a9a97b4fc3d55c9cd.svg";